<template>
  <generic-modal :title="$t('billing')" ref="generic_modal">
    <div class="title is-4">
      {{ meta.name }} <small> | {{ format_date(meta.create_date) }}</small>
    </div>
    <div class="subtitle">
      <span>{{ meta.grade }} | {{ meta.phone }} | {{ meta.email }} </span>
    </div>

    <div
      class="title is-4 mt-6"
      v-if="
        meta.settings && meta.settings.billing_name && meta.settings.billing_nit
      "
    >
      {{ $t("billing information") }}
    </div>
    <div
      class="subtitle mb-1"
      v-if="
        meta.settings && meta.settings.billing_name && meta.settings.billing_nit
      "
    >
      <span class="icon">
        <i class="fa fa-user"></i>
      </span>
      <span>{{ $t("name") }} {{ meta.settings.billing_name }}</span>
    </div>
    <div
      class="subtitle"
      v-if="
        meta.settings && meta.settings.billing_name && meta.settings.billing_nit
      "
    >
      <span class="icon">
        <i class="fa fa-id-card"></i>
      </span>
      <span>{{ $t("nit") }} {{ meta.settings.billing_nit }}</span>
    </div>
    <div class="title is-4 mt-6">{{ $t("order") }}</div>
    <div class="content">
      <ul>
        <li v-for="(product, pidx) in meta.tailoring_order_items" :key="pidx">
          <span>{{ Number(product.quantity) }}</span> x
          <span>{{ product.product.name }}, </span>
          <span>{{ $t("size") }} {{ product.size.toUpperCase() }}</span>
          <span v-if="product.customization">
            ({{ product.customization }})</span
          >
          <span class="is-pulled-right">{{
            format_currency(Number(product.quantity) * Number(product.price))
          }}</span>
        </li>
      </ul>
    </div>
    <div class="title is-4 is-pulled-right">
      {{ $t("total") }} {{ format_currency(meta.total) }}
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  generate_error_message_text,
  format_date,
  download,
  api_host,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "OrderModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      show_receipt: false,
      target_filename: "",
      api_host,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.name || !v.meta.username || !v.meta.password;
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(profile) {
      let v = this;
      v.set_initial_state();
      v.meta = profile;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      v.$emit("success", profile);
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        name: "",
      };
      v.error = "";
      v.show_receipt = false;
      v.target_filename = "";
    },
    download_payment_document(payment) {
      console.log(payment);
      // let v = this;

      let final_name_has_extension =
        payment.document_file.settings.final_name.includes(".");
      if (final_name_has_extension) {
        let url = `${api_host}/drive/static/${payment.document_file.settings.final_name}`;
        window.open(url, "_blank");
        return;
      } else {
        let mimetype = payment.document_file.settings.mimetype;
        let download_extension = "";
        if (mimetype == "application/pdf") download_extension = "pdf";
        else if (mimetype == "image/jpeg") download_extension = "jpg";
        else if (mimetype == "image/png") download_extension = "png";
        else if (mimetype == "text/plain") download_extension = "txt";
        else if (
          mimetype ==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        )
          download_extension = "docx";
        else if (
          mimetype ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
          download_extension = "xlsx";
        else if (
          mimetype ==
          "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        )
          download_extension = "pptx";
        else if (mimetype == "application/vnd.ms-excel")
          download_extension = "xls";
        else if (mimetype == "application/msword") download_extension = "doc";

        let url = `${api_host}/drive/static/${payment.document_file.settings.final_name}`;
        let download_name = `payment_receipt_order_${payment.order_id}.${download_extension}`;
        fetch(url)
          .then((response) => {
            return response.blob();
          })
          .then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = download_name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error(error);
          });
      }
      // let url = `${api_host}/tailoring_order/payment_document/${payment.uuid}`;
      // download(url, "payment_document");
      // let final_name = payment.document_file.name;

      // let url = `${api_host}/drive/static/${payment.document_file.settings.final_name}`;
      // window.open(url, "_blank");

      // download(url, final_name)
      //   .then(() => {
      //     console.log("downloaded");
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
